import { useEffect, useState } from "react";
import notice from "../assets/dummy/DataNotice";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";

function CompNotice(props) {
  const history = useHistory();
  const [data, setData] = useState({});
  const id = Number(props.match.params.id);

  useEffect(() => {
    // 순서와 무관하게 id로 매칭
    const item = notice.Notice.find((n) => Number(n.id) === id) || null;
    setData(item);
  }, [id]);

  const sortedById = [...notice.Notice].sort(
    (a, b) => Number(a.id) - Number(b.id)
  );
  const curIndex = sortedById.findIndex((n) => Number(n.id) === Number(id));
  const prevItem = curIndex > 0 ? sortedById[curIndex - 1] : null;
  const nextItem =
    curIndex >= 0 && curIndex < sortedById.length - 1
      ? sortedById[curIndex + 1]
      : null;

  return (
    <>
      <h2 className="basic-title">공지사항</h2>
      <div className="basic-subtitle news-subtitle">
        <p>공지 사항을 확인해주세요.</p>
      </div>
      {data ? (
        <div className="notice-wrap notice-page">
          <h2 className="notice-title">{data.title}</h2>
          <div className="notice-date">
            <p>작성자 :&nbsp; 헬리오센</p>
            <p>작성일 :&nbsp;{data.date}</p>
          </div>

          <div>
            <div
              className="notice-cont"
              dangerouslySetInnerHTML={{ __html: data.contents }}
            ></div>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* <button className="black-btn" onClick={() => props.history.goBack()}>
        목록보기
      </button> */}
      <button
        className="black-btn"
        onClick={() => {
          history.push("/promotion/notice");
        }}
      >
        목록보기
      </button>

      <div className="notice-nav-wrap">
        {/* 이전글 */}
        <div className="notice-nav">
          <div className="notice-label">
            <span>이전글</span>
          </div>
          <div className="notice-txt">
            {prevItem ? (
              <Link to={`/promotion/notice/${prevItem.id}`}>
                {prevItem.title}
              </Link>
            ) : (
              "이전 글이 없습니다."
            )}
          </div>
        </div>

        {/* 다음글 */}
        <div className="notice-nav">
          <div className="notice-label">
            <span>다음글</span>
          </div>
          <div className="notice-txt">
            {nextItem ? (
              <Link to={`/promotion/notice/${nextItem.id}`}>
                {nextItem.title}
              </Link>
            ) : (
              "다음 글이 없습니다."
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default CompNotice;
